import { Component, input } from '@angular/core';
import { FiltersPanelHeadComponent } from '@app/core/components/filters-panel-head/filters-panel-head.component';

@Component({
  selector: 'pwj-filters-panel',
  standalone: true,
  imports: [FiltersPanelHeadComponent],
  templateUrl: './filters-panel.component.html',
  styleUrl: './filters-panel.component.scss',
})
export class FiltersPanelComponent {
  titleKey = input.required<string>();
  icon = input<string>('filter-search');
}
